import { SxProps, Theme, Typography } from "@mui/material";

export function QaToolHeader({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Typography variant="h6" component="h1" sx={sx}>
      Center Stage QA Tool
    </Typography>
  );
}
